import { primitiveColorTokens } from '@cellula/react-theme-patient';

export function BrandedIllustrationPhoneOngoing() {
	return (
		<svg viewBox='0 0 400 256' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<circle stroke='none' cx='229' cy='93' r='64' fill={primitiveColorTokens.primary['500']} />
			<circle stroke='none' cx='229' cy='89' r='64' fill={primitiveColorTokens.primary['400']} />
			<path
				stroke='none'
				d='M243.25 72.375C243.25 80.2451 236.87 86.625 229 86.625C221.13 86.625 214.75 80.2451 214.75 72.375C214.75 64.5049 221.13 58.125 229 58.125C236.87 58.125 243.25 64.5049 243.25 72.375Z'
				fill={primitiveColorTokens.primary['700']}
			/>
			<path
				stroke='none'
				d='M200.5 112.75C200.5 103.422 206.064 95.4708 216.942 92.42C221.958 91.0133 236.138 91.0401 241.058 92.42C251.936 95.4708 257.5 103.422 257.5 112.75V115.125C257.5 117.748 255.373 119.875 252.75 119.875H205.25C202.627 119.875 200.5 117.748 200.5 115.125V112.75Z'
				fill={primitiveColorTokens.primary['700']}
			/>
			<path
				stroke='none'
				d='M89.0315 69.1636C92.6106 159.061 162.976 229.427 252.8 232.932C264.716 233.421 274.83 223.307 275.096 211.374L275.501 193.249C275.74 182.525 267.86 173.718 257.314 172.746L230.647 170.322C224.32 169.708 217.851 172.042 213.142 176.751L193.805 196.087C193.503 196.39 193.04 196.467 192.657 196.276C163.672 181.84 140.12 158.436 125.686 129.306C125.496 128.923 125.573 128.461 125.875 128.159L145.29 108.745C149.922 104.112 152.255 97.6441 151.719 91.2399L149.292 64.7236C148.245 54.1036 139.513 46.2972 128.788 46.5366L110.663 46.9412C98.6568 47.1337 88.6164 57.3218 89.0315 69.1636Z'
				fill={primitiveColorTokens.primary['600']}
			/>
			<path
				stroke='none'
				d='M89.0315 65.3081C92.6106 155.206 162.976 225.571 252.8 229.077C264.716 229.566 274.83 219.451 275.096 207.519L275.501 189.394C275.74 178.669 267.86 169.863 257.314 168.89L230.647 166.466C224.32 165.853 217.851 168.186 213.142 172.896L193.805 192.232C193.503 192.535 193.04 192.611 192.657 192.42C163.672 177.984 140.12 154.58 125.686 125.45C125.496 125.067 125.573 124.606 125.875 124.304L145.29 104.889C149.922 100.257 152.255 93.7886 151.719 87.3844L149.292 60.8681C148.245 50.2482 139.513 42.4418 128.788 42.6811L110.663 43.0857C98.6568 43.2783 88.6164 53.4663 89.0315 65.3081Z'
				fill={primitiveColorTokens.primary['700']}
			/>
		</svg>
	);
}
